// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v6 — see `ChannelModifier.schema_version`.
 *
 * Policy governing how a channel
 * modifier resolves CONFLICTS with other modifiers that emit to the SAME target
 * channel + target message. Conflicts are keyed on the TARGET (different source
 * channels/messages can map to one target). Within a conflict group the
 * highest-precedence modifier (lowest `priority` value) governs; its policy
 * decides the fate of the lower-precedence modifiers in the group. Applies to
 * BEFORE/AFTER modifiers (which emit a target payload); IN_FLIGHT modifiers
 * mutate the source in place and never participate in target conflicts.
 *   COEXIST (0)        — all conflicting modifiers fire (legacy/default).
 *   CANCEL_LOWER (1)   — only the governing modifier fires; lower ones suppressed.
 *   OVERRIDE_LOWER (2) — the governing modifier's emission overrides (replaces)
 *                        the lower-precedence modifiers' emissions to that target.
 *   `MERGE` (3)          — the group's `BitMaskMessage` emissions are OR-collapsed into
 *                        one frame (non-BitMask degrades to governing-wins + warn).
 *   QUEUE (4)          — emissions serialized in priority-ASC order, one per
 *                        sweeper tick (AFTER modifiers only).
 * `COEXIST` MUST stay value 0 so pre-v6 rows (reading the field as its `FlatBuffer`
 * default) preserve today's all-fire behavior.
 */
export enum ConflictPolicy {
  COEXIST = 0,
  CANCEL_LOWER = 1,
  OVERRIDE_LOWER = 2,
  MERGE = 3,
  QUEUE = 4,
}
